import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { ApiContext } from "../../UseContext/ApiCall";
import { BASE_URL_STATIC, BASEAPIURL } from "../../../../config";

const LikeMemeButton = ({ postedBy , memeId }) => {

  const [like, setLike] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  const { config, socket } = useContext(ApiContext);

  // To fetch meme like status
  const getMemeLikeStatus = async (memeId, config) => {
    await axios.post(`${BASEAPIURL}/post/checkmemelike`, { postId: memeId }, config )
    .then((res) => {
      // console.log(res.data.liked);
      setLike(res.data.liked);
    })
    .catch((err) => {
      return null;
    });
  };

  useEffect(() => {
    getMemeLikeStatus(memeId, config);
  }, [memeId]);

  // To fetch meme like count
  const getMemeLikeCount = async (memeId, config) => {
    await axios.post(`${BASEAPIURL}/post/countmemelike`, { postId: memeId }, config )
    .then((res) => {
      // console.log(res.data.memeCount);
      setLikeCount(res.data.memeCount);
    })
    .catch((err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    getMemeLikeCount(memeId, config);
  }, [likeCount]);

  // To handle like or dislike
  const handleMemeLike = async (memeId, config) => {
    const action = like ? "like" : "dislike";

    await axios.post( `{$}BASEAPIURL/post/likememe`, { postId: memeId, postType : "meme", postedBy , eventType: action }, config )
    .then((res) => {
      // console.log(res.data);
      setLike(!like);

      if (like) {
        setLikeCount(likeCount + 1);
      } else {
        setLikeCount(likeCount - 1);
      };

      // For notification
      axios.post(`${BASEAPIURL}/user/createemnotification`, { memeId: memeId, action: action, type: 'like' }, config)
      .then(res => {
        // console.log(res);

        let notificationData = {
          type: res.data.type,
          action: res.data.action,
          senderUserId: res.data.senderUserId && res.data.senderUserId,
          receiverUserId: res.data.receiverUserId && res.data.receiverUserId,
          message: res.data.message && res.data.message,
          createdAt: res.data.createdTime && res.data.createdTime,
          fname: res.data.fname && res.data.fname,
          memeId: res.data.memeId && res.data.memeId,
          postImg: res.data.postImg && res.data.postImg,
          profileImg: res.data.profileImg && res.data.profileImg,
          tumbnailImg: res.data.tumbnailImg && res.data.tumbnailImg,
        }

        socket.emit("send_message_emilo_notification", notificationData);
        console.log(notificationData);
      })
      .catch(err => {
        console.log(err);
      });
    })
    .catch((err) => {
      console.log(err);
    });
  };

  return (
    <>
      {
        like
        ?
        <div className="d-flex" style={{ alignItems: 'center' }}>
          <img className="likeMemeBtn" src={`${BASE_URL_STATIC}/icon/like-1.svg`} alt="comment" onClick={() => handleMemeLike(memeId, config)} style={{ marginRight: "5px", cursor: 'pointer' }} />
          <span>{likeCount}</span>
        </div>
        :
        <div className="d-flex" style={{ alignItems: 'center' }}>
          <img className="likeMemeBtn" src={`${BASE_URL_STATIC}/icon/like-2.svg`} alt="comment" onClick={() => handleMemeLike(memeId, config)} style={{ marginRight: "5px", cursor: 'pointer' }} />
          <span>{likeCount}</span>
        </div>
      }
    </>
  );
};

export default LikeMemeButton;
